import Voucher from '@components/Voucher/Voucher.component'
import { BUTTON_KIND, BUTTON_SIZE } from 'parkdepot-shared/components/Buttons'
import { B2COrderResponseFragment } from 'parkdepot-shared/gql/graphql'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ActionsContainer } from './CarpayOrderActions.style'
import Button from 'parkdepot-shared/components/Buttons/Button'
import { CodeScanner } from '@components/CodeScanner/CodeScanner.component'

const PaymentOrDiscountActions = ({
    orderData,
    allowDiscount,
    onPay
}: {
    orderData: B2COrderResponseFragment
    allowDiscount: boolean
    onPay: () => void
}) => {
    const { t } = useTranslation()

    return (
        <ActionsContainer>
            <Button id="pay-button" $kind={BUTTON_KIND.primary} onClick={onPay} $size={BUTTON_SIZE.medium}>
                {t('carpay.orderActions.pay')}
            </Button>

            <CodeScanner orderData={orderData} disabled={!allowDiscount} />

            <Voucher orderData={orderData} disabled={!allowDiscount} />
        </ActionsContainer>
    )
}

export default PaymentOrDiscountActions
